import React, { useContext } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';

import { FieldContained } from '@ad-scripts/presentation/components/common/textarea_field';
import FormContext from 'src/presentation/contexts/FormContext';
import MemoSelector, { MemorySelectorResult } from './Rule/MemorySelector';
import { StyledRow } from 'src/presentation/components/pages/sidekick/threads/components/Layout';
import { TypeSpec, Type } from 'src/models/Sidekick/SidekickModuleSpec';
import { useCondition } from './Rule/useCondition';
import { ThreadModuleContext } from '../ThreadModuleContext';
import { Row } from './controls/Layout';

export default function FilterBy({ attr, typeSpec }: { attr: string; typeSpec: TypeSpec }) {
  const { readOnly } = useContext(ThreadModuleContext);
  const { workingState, onBlur } = useContext(FormContext);
  const fields = get(workingState, attr) || [];

  const { currentFields, setCurrentFields, optGroups } = useCondition({
    fields,
    allowEnterManually: false,
    typeSpec: Type.array as any,
    compatibilityMatch: false,
    includeOnlyNestedProps: true,
  });

  const handleChangeMemoFields = props => {
    const currentProperties = props.currentState;
    const value = get(currentProperties, attr, []);
    const newProps = { currentState: set(currentProperties, attr, value) };
    onBlur && onBlur(newProps);
  };

  return (
    <Row>
      <FieldContained
        attr={attr}
        label={typeSpec.prompt}
        control={
          <StyledRow>
            <MemoSelector
              attr={attr}
              disabled={readOnly}
              isEnterManually={false}
              optGroups={optGroups}
              fields={currentFields}
              setCurrentFields={setCurrentFields}
              onChange={handleChangeMemoFields}
              resultType={MemorySelectorResult.ARRAY}
            />
          </StyledRow>
        }
      />
    </Row>
  );
}
